import RecommendationContainer from '../../components/recommendation-container';

export default RecommendationContainer;
